import { csx } from '@vtex/admin-ui'

export const modalBackdrop = csx({
  zIndex: '9999 !important',
})

export const modalAction = csx({
  width: '100%',
})
